import { getHomePageData } from "@/api/pageData.js";
export default {
  getAllData({ dispatch, commit }) {
    getHomePageData().then((res) => {
      commit("setStateData", {
        key: "carouselData",
        val: res.data.Carousel.data,
      });
      commit("setStateData", {
        key: "commonColumnData",
        val: res.data.PageEdit.data,
      });
      commit("setStateData", {
        key: "pageMetaData",
        val: res.data.PageMetaData.data,
      });

      commit("setStateData", {
        key: "newsCategoryData",
        val: res.data.NewsCategory.data,
      });
      commit("setStateData", {
        key: "newsData",
        val: res.data.News.data,
      });

      commit("setStateData", {
        key: "videoCategoryData",
        val: res.data.VideoCategory.data,
      });
      commit("setStateData", {
        key: "videoData",
        val: res.data.Video.data,
      });

      commit("setStateData", {
        key: "zipCodeData",
        val: res.data.ZipCode.data,
      });
      commit("setStateData", {
        key: "paymentData",
        val: res.data.Payment.data,
      });
      commit("setStateData", {
        key: "shipwayData",
        val: res.data.Shipping.data,
      });
      commit("setStateData", {
        key: "dealerData",
        val: res.data.Dealer.data,
      });
      commit("setStateData", {
        key: "brandData",
        val: res.data.Brand.data,
      });

      dispatch("getProductData", res.data.Goods.data);
      dispatch("getCategoryData", res.data.Menu.data);
      dispatch("getParentCategoryData", res.data.MenuCategory.data);
    });
  },
  // 取得商品分類與獨立銷售頁資料
  getCategoryData(state, data) {
    // 依照後台設定的排序，排序資料
    let tmpData = data.sort((a, b) => {
      return parseInt(a.Seq) - parseInt(b.Seq);
    });

    // 商品分類為Content5不等於獨立銷售頁的資料
    let category = tmpData.filter((item) => item.Content5 != "獨立銷售頁");
    state.commit("setStateData", {
      key: "categoryData",
      val: category,
    });

    // 篩選有設定限制時間，且已經超出時間範圍的資料
    category = category.filter((item) => {
      if (item.MenuTimeEnd != null) {
        return new Date() < new Date(item.MenuTimeEnd);
      } else {
        return true;
      }
    });

    // 獨立銷售頁為Content5等於獨立銷售頁的資料
    const event = tmpData.filter((item) => item.Content5 == "獨立銷售頁");
    state.commit("setStateData", {
      key: "eventData",
      val: event,
    });
  },
  // 取得商品目錄
  getParentCategoryData({ commit }, data) {
    // 篩選不顯示的目錄
    let tmpData = data.filter((item) => {
      return item.Status != "N";
    });
    commit("setStateData", {
      key: "menuCategoryData",
      val: tmpData,
    });
  },
  // 取得商品資料
  getProductData({ commit }, data) {
    // 篩選已刪除商品
    let tmpData = data.filter((item) => {
      return item.deleted_at == null && item.Status == "Y";
    });
    // 篩選停用的庫存，並判斷若商品沒有圖片則顯示預設圖片
    tmpData.forEach((item, item_index) => {
      tmpData[item_index].Stock = item.Stock.filter(
        (stock) => stock.Status == "Y"
      );
      if (item.Image1 == "") {
        tmpData[item_index].Image1 = "/image/product_default.webp";
      }
    });
    // 篩選掉沒有庫存選項的一般商品
    tmpData = tmpData.filter(
      (item) => item.Stock.length > 0 || item.IsCustom == "Y"
    );
    // 排序
    tmpData = tmpData.sort((a, b) => {
      return parseInt(a.Seq) - parseInt(b.Seq);
    });
    commit("setStateData", {
      key: "allProductData",
      val: data,
    });
    commit("setStateData", {
      key: "productData",
      val: tmpData,
    });
    commit("shopCartModule/SetProductData", tmpData, {
      root: true,
    });
  },
};
